module.exports = __webpack_public_path__ + "static/media/shape0_4.00f3991e.obj";